const Register = () => {
  return (
    <div>
      <form>
        <label>Create username:</label>
        <input type="text"></input>
        <br />
        <label>Create password:</label>
        <input type="password"></input>
        <br />
        <label>Confirm password</label>
        <input type="password"></input>
        <br />
        <button>Register</button>
      </form>
    </div>
  )
}

export default Register;